import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import {Box} from "@mui/material";

// global components
import {AgreeTerms} from "../../../../designSystem/components/AgreeTerms";
import {Typography} from "../../../../designSystem/components/Typography";
import {BigButton} from "../../../../designSystem/components/BigButton";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";
import {Dialog} from "../../../../designSystem/components/Dialog";

// shared components
import {PlatformBottomNavbar} from "../../../../widgets/PlatformBottomNavbar";
import {FormPageLayout} from "../../../../components/layout/FormPageLayout";

import {CATEGORIES} from "../../../../utils/constants";
import {getLiffId} from "../../../../utils/liff";

import {useLineLogin} from "../../../../hooks/useLineLogin";

export const ChooseApplicationCategoryFeature = () => {
  const navigate = useNavigate();
  const [isCheckedUserUsageTerms, setIsCheckedUserUsageTerms] = useState(false);
  const [dialogContent, setDialogContent] = useState('');

  const { lineUserId, lineUserName, lineProfilePic } = useLineLogin({ liffId: getLiffId('PLATFORM_PAGE') })

  const handleOnClickItem = (itemPath) => {
    if (!isCheckedUserUsageTerms) {
      setDialogContent('notSelectedTerms');
      return;
    }
    const newCase = {
      userLineId: lineUserId,
    }
    localStorage.setItem('newCase', JSON.stringify(newCase));
    navigate(`/newApplicationStep1/${itemPath}`);
  }

  const handleCloseDialog = () => {
    setDialogContent('');
  }

  return (
    <React.Fragment>
      <FormPageLayout
        rightProfilePic={lineProfilePic}
        body={
          <Box>
            <Box className="flex flex-col bg-gray-100 px-8 py-6 overflow-y-scroll gap-4 h-[calc(100vh-125px)]">
              {/* line greeting */}
              {lineUserId && (
                <div className="text-lg text-gray-700 text-center">
                  歡迎, <span className="font-semibold">{lineUserName}</span>
                </div>
              )}

              {/* agreement */}
              <div className="flex flex-col items-center">
                <AgreeTerms
                  name="個人資料使用授權"
                  isChecked={isCheckedUserUsageTerms}
                  onChangeCheck={() => setIsCheckedUserUsageTerms(!isCheckedUserUsageTerms)}
                  onClickLink={() => navigate('/userUsageTerms')}
                />
                <span className="mt-2">
                  (代病患申請請務必獲得病患或家屬同意)
                </span>
              </div>

              {/* service category selection */}
              <Typography variant="title" align="center">
                請選擇服務項目
              </Typography>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 w-full max-w-4xl">
                {CATEGORIES.map((item, index) => (
                  <BigButton
                    key={index}
                    onClick={() => handleOnClickItem(item.path)}
                    color={item.badgeColor}
                    icon={item.icon}
                    label={item.label}
                  />
                ))}
              </div>
            </Box>
            <PlatformBottomNavbar
              onClickRightButton={() => navigate('/applicationList')}
              selectedTab="new-application"
            />
          </Box>
        }
      />
      <Dialog isOpen={dialogContent !== ''}>
        {dialogContent === 'notSelectedTerms' ? (
          <TwoButtonDialog
            type="warning"
            title="請同意個人資料使用授權"
            leftLabel="了解"
            leftOnClick={handleCloseDialog}
            leftIconName="fa-check"
          />
        ) : null}
      </Dialog>
    </React.Fragment>
  );
}